export const ENTITY_TYPE_PROVIDER = "Provider";
export const ENTITY_TYPE_LAW_FIRM = "Law Firm";
export const ENTITY_TYPE_CCM = "Client Case Management";
export const PRIMARY_CLIENT_MANAGER = "primaryclientmanager";
export const IS_EXPAND_FOLLOW_UP = "is_expand_follow_up";
export const DOCUMENT_TYPES = {
  DRIVER_LICENSE_FRONT: 11,
  DRIVER_LICENSE_BACK: 25,
};
export const APPT_STATUS = {
  Done: "Complete",
  Overdue: "Missed",
  Assigned: "Scheduled",
};

export const ENTITY_TYPES = {
  CLIENT_CASE_MANAGEMENT: 1,
  LAW_FIRM: 2,
  PROVIDER: 3,
  PAYMENT_PROCESSOR: 4,
  ORGANIZATION: 5,
};
export const GROUPS = {
  FINANCE: "finance",
  MEDICAL_RECORDS: "medical-records",
  MCC: "mcc",
};
export const REDIRECT_URLS = {
  FINANCE: "/finance/cases/list",
  DASHBOARD:
    "/dashboard?offset=0&limit=100&overall_status__in=Active%2CActive+-+Client+Unresponsive%2CActive+-+Paused+%28See+Note%29%2CActive+-+Waiting+on+Limits",
  MEDICAL_RECORDS: "/medical-records/cases/list",
  MCC: `/mcc?offset=0&limit=1000&status=pending`,
};

export const DEFAULT_PAGINATION_LIMIT = 25;

export const VIEW_DOCUMENTS_TITLE = "Documents";

export const SHOW_MORE_AMOUNT = 10;
